import parseCustomDashboardFilters from '@utils/parseCustomDashboardFilters'
import { parseExtraFiltersIndicators, parseFiltersIndicators } from '@utils/parseFiltersIndicators'
import parseLcmFilters from '@utils/parseLcmFilters'
import RestApiBuilder from '@utils/RestApiBuilder'
import { ApisauceInstance } from 'apisauce'
import useClientConfig from 'config/clients/useClientConfig'



/**
 * Expose all endponts for 'reports'.
 */
export default <T>(vocApi: ApisauceInstance, lcmApi: ApisauceInstance): ApiObject => ({
  ...RestApiBuilder<T>('indicators', vocApi),
  data: (url: string, filters: any, filtersData: Record<string, any>, extras: any) => {
    //console.log(`API get data for ${url}`)
    //console.log(filters)
    //console.log(extras)

    const useLcmApi = extras !== undefined
      && extras.useLcmApi !== undefined
      && extras.useLcmApi

    if (useLcmApi) {
      let lcmFilters = {
        ...parseLcmFilters(filters, filtersData, extras)
      }

      if (url === 'dashboard/status') {
        delete lcmFilters.geoLocations
      }

      return lcmApi.get(url, lcmFilters)
    }

    // Custom dashboard filters


    var finalFilters = {
      ...parseFiltersIndicators(filters, extras),
      ...parseExtraFiltersIndicators(extras),
      ...parseCustomDashboardFilters(filters, extras)
    }

    return vocApi.post(url, finalFilters)
  },
  comments: (tag: string, filters: FiltersUI, extras: any) => {
    const { getSentimentCommentsIndicatorName } = useClientConfig()
    //console.log('API get comments')
    //console.log(extras)
    return vocApi.post('indicators/' + getSentimentCommentsIndicatorName() + '/values', {
      limit: 100,
      ...parseFiltersIndicators(filters, extras),
      ...parseExtraFiltersIndicators(extras),
      ...parseCustomDashboardFilters(filters, extras),
      tag
    })
  },
  dynamicDashboard: (cmId: number) => {
    return vocApi.get(`dashboard/critical-moment/${cmId}`, {})
  },
})
